import objectTypes from '../../constants/ObjectTypes';
import storeManager from '../../store/StoreManager';
import assessmentReader from './AssessmentReader';

const tocReader = {
    getSectionIdForQuestionId(questionId) {
        const questionLocation = this.getQuestionLocation(questionId);

        if (questionLocation) {
            return questionLocation.sectionId;
        }
        return undefined;
    },

    getQuestionLocation(questionId) {
        const { toc } = storeManager.getState();

        if (toc.itemsMap[questionId] !== undefined) {
            return toc.itemsOrder[toc.itemsMap[questionId]];
        }
        return toc.sectionStimulusMap[questionId];
    },

    getNextQuestionLocation(questionId) {
        const state = storeManager.getState();
        const { itemsOrder } = state.toc;
        const currentLocationData = itemsOrder.find((item) => {
            return item.contentRevisionId === questionId;
        });

        if (currentLocationData && !currentLocationData.isLastQuestion) {
            return itemsOrder[currentLocationData.overallIndex + 1];
        }

        return undefined;
    },

    getPreviousQuestionLocation(questionId) {
        const state = storeManager.getState();
        const { itemsOrder } = state.toc;
        const indexOfQuestion = itemsOrder.findIndex((item) => {
            return item.contentRevisionId === questionId;
        });

        if (indexOfQuestion - 1 > -1) {
            const locationData = itemsOrder[indexOfQuestion - 1];
            return locationData;
        }

        return undefined;
    },

    getLastQuestionLocation() {
        const state = storeManager.getState();
        const { itemsOrder } = state.toc;
        const locationData = itemsOrder[itemsOrder.length - 1];

        if (locationData) {
            locationData.isFirstQuestion = itemsOrder.length === 1;
            locationData.isLastQuestion = true;

            return locationData;
        }

        return undefined;
    },

    getFirstQuestionLocation() {
        const state = storeManager.getState();
        const { itemsOrder } = state.toc;
        const locationData = itemsOrder[0];

        if (locationData) {
            locationData.isFirstQuestion = true;
            locationData.isLastQuestion = itemsOrder.length === 1;

            return locationData;
        }

        return undefined;
    },

    getFirstQuestionInSectionLocation(sectionId) {
        const section = assessmentReader.getSectionById(sectionId);
        const question = section?.questions?.[0];
        return question ? this.getQuestionLocation(question.contentRevisionId) : undefined;
    },

    getStimulusLocation(contentRevisionId) {
        const state = storeManager.getState();
        const { sectionStimulusMap } = state.toc;
        return sectionStimulusMap[contentRevisionId];
    },

    isSectionStimulus(contentRevisionId) {
        return !!this.getStimulusLocation(contentRevisionId);
    },

    isTocPage() {
        const state = storeManager.getState();
        return state.currentlyShown.route === '/';
    },

    getQuestionItems() {
        const { toc: { itemsOrder } } = storeManager.getState();
        return itemsOrder.filter(item => item.type === objectTypes.CATEGORY.QUESTION);
    },
};

export default tocReader;
